import { FaRegStar, FaStar, FaStarHalfAlt } from "react-icons/fa";

{/*RATING RENDERER*/
}

export const renderStars = (rating: number) => {
    const fullStars = Math.floor(rating);
    const halfStar = rating % 1 !== 0;
    const emptyStars = 5 - fullStars + (halfStar ? -1 : 0);

    return (
        <>
            {[...Array(fullStars)].map((_, index) => (
                <FaStar key={index} className="w-6 h-6 ml-1 text-[#FFC633]" />
            ))}
            {halfStar && (
                <FaStarHalfAlt className="w-6 h-6 ml-1 text-[#FFC633]" />
            )}
            {[...Array(emptyStars)].map((_, index) => (
                <FaRegStar key={index} className="w-6 h-6 ml-1 text-[#FFC633]" />
            ))}

        </>
    );
};

{/*PRODUCT DISCOUNT CALCULATOR*/ }
// export const calculateDiscountedPrice = (price: number, discount: number, b2bDiscount: number): any => {
//         const b2bDiscountAmount = price * (b2bDiscount / 100);
//         const discountedPrice = b2bDiscount && b2bDiscount > 0 ? price - (price * (discount / 100)) - b2bDiscountAmount : price - (price * (discount / 100));
//         return discountedPrice % 1 !== 0 ? discountedPrice.toFixed(2) : discountedPrice.toFixed(0);
//     };

export const calculateDiscountedPrice = (
    price: number,
    discount: number,
    b2bDiscount: number,
    exchangeRate: number
  ): number => {
    const priceInCurrency = price * exchangeRate;
  
    const b2bDiscountAmount = priceInCurrency * (b2bDiscount / 100);
  
  
    const discountedPrice =
      b2bDiscount && b2bDiscount > 0
        ? priceInCurrency - priceInCurrency * (discount / 100) - b2bDiscountAmount
        : priceInCurrency - priceInCurrency * (discount / 100);
  
    return parseFloat(discountedPrice.toFixed(1));
  };

{/*DATE FORMATTER*/
}
export const formatISODate = (isoDate: string) => {
    const date = new Date(isoDate);
    const options: Intl.DateTimeFormatOptions = {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    };
    return date.toLocaleDateString('tr-TR', options);
};


// price Formatter
export const formatPrice = (price: any): any => {
    return new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY'
    }).format(price);
}



  